import { render, staticRenderFns } from "./ForeignLanguagesFormComponent.vue?vue&type=template&id=a7425744&xmlns=true&"
import script from "./ForeignLanguagesFormComponent.vue?vue&type=script&lang=js&"
export * from "./ForeignLanguagesFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7425744')) {
      api.createRecord('a7425744', component.options)
    } else {
      api.reload('a7425744', component.options)
    }
    module.hot.accept("./ForeignLanguagesFormComponent.vue?vue&type=template&id=a7425744&xmlns=true&", function () {
      api.rerender('a7425744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-attraction/basic-data/forms/foreign-languages-form/ForeignLanguagesFormComponent.vue"
export default component.exports